import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import styles from "./index.module.scss";
// import Slider from "react-slick";
import Desc from "./components/Desc/index";
import Product from "./components/Product/index";
import Swiper from "@/components/Swiper";
import axios from "@/util/axios";
import ReactSwipe from 'react-swipes';
import { api } from "@/routes/api";
import NoProductIcon from '@/images/no-product-list.png';
import { changeLoading } from '@/redux/base.redux';
const { getProductList } = api;

@connect(
  state => state.base,
  { changeLoading }
)
class Index extends Component {
  state = {
    swipe_index: 0,
    productList: [],
    isTag: false,
    menuInfo: {},
    count: 0
  };
  componentDidMount() {
    this.getProductList();
  }
  componentDidUpdate() {
    if (!this.state.isTag && this.props.menuArrayList.length) {
      this.setState({ isTag: true });
      this.getCats();
    }
  }
  componentWillReceiveProps(nextProps) {
    const { id } = this.props.match.params;
    if (nextProps.match.params.id !== id) {
      this.getProductList(nextProps)
      this.getCats(nextProps);
    }
  }
  getCats = (nextProps) => {
    const { id } = nextProps ? nextProps.match.params : this.props.match.params;
    const item = this.props.menuArrayList.filter(v => parseInt(v.id) === parseInt(id));
    this.setState({ menuInfo: item[0] });
  }
  getProductList = async (nextProps) => {
    const { id } = nextProps ? nextProps.match.params : this.props.match.params;
    if (id) {
      this.props.changeLoading(true);
      const res = await axios.post(getProductList, { catsId: id });
      if (res.code === 0) {
        this.setState({ productList: res.data.data, ambulance: res.ambulance, count: res.data.count });
      }
      setTimeout(() => this.props.changeLoading(false), 500);
    }
  }

  renderSwiper = (productList) => {
    const { ambulance } = this.state;
    return (
      <div>
        <ul>
          {JSON.parse(JSON.stringify(productList)).splice(2, productList.length).map(product => (
            <li key={product.id}>
              <a href={product.buy_url} target="view_window">
                <div className={styles.image_container}>
                  <img src={ambulance + product.photo} alt=""/>
                  <div className={styles.text_container}>
                    <div className={styles.product_name}>{product.name}</div>
                    <div className={styles.product_tips}>{product.tips}</div>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const { menuInfo, productList, ambulance, count } = this.state;
    const opt = {
      distance: 245, //每次移动的距离，卡片的真实宽度
      autoPlay: false, //是否开启自动播放
      swTouchstart: (ev) => { },
      swTouchmove: (ev) => { },
      swTouchend: (ev) => {
        let data = {
          moved: ev.moved,
          originalPoint: ev.originalPoint,
          newPoint: ev.newPoint,
          calcelled: ev.calcelled
        }
        if (data.newPoint === 0) {
          this.setState({ swipe_index: 0 });
        } else {
          this.setState({ swipe_index: 1 });
        }
      }
    };
    const { swipe_index } = this.state;
    return (
      <div className="glasses">
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img src="/images/top_banner.jpg" alt="banner" />
        </div>
        <div className={styles.men_glasses}>
          <div className={styles.title_container}>
            <Desc style={{ textAlign: "center" }} info={menuInfo} />
            <div className={styles.line}></div>
          </div>
          <div className={styles.product_container}>
            {count === 0 ? (
              <div className={styles.noTips}>
                <img src={NoProductIcon} alt="" style={{ width: 100 }} />
                <div>暂无产品</div>
              </div>
            ) : (
                <Fragment>
                  {count > 0 ? (
                    <a href={productList[0].buy_url} target="view_window">
                      <div className={styles.product_left}>
                        <img src={ambulance + productList[0].photo} alt={productList[0].name} />
                        <Product info={productList[0]} />
                      </div>
                    </a>
                  ) : null}
                  <div className={styles.product_right}>
                    <div className={styles.title}>DESIGN FOR TEA</div>
                    {count > 1 ? (
                      <a href={productList[1].buy_url} target="view_window">
                        <div className={styles.img_container}>
                          <img src={ambulance + productList[1].photo} alt={productList[1].name} />
                          <Product info={productList[1]} />
                        </div>
                      </a>
                    ) : null}
                  </div>
                </Fragment>
              )}
          </div>
          <div className={styles.app_product_container}>
            {count === 0 ? (
              <div className={styles.noTips}>
                <img src={NoProductIcon} alt="" style={{ width: 100 }} />
                <div>暂无产品</div>
              </div>
            ) : (
              <div>
                <ReactSwipe className={styles.app_slide_container} options={opt}>
                  <a href={productList[0].buy_url} target="view_window" className={`${styles.app_slide_item} ${styles.margin_right15}`}>
                    <div className={styles.product_item}>
                      <img src={ambulance + productList[0].photo} alt={productList[0].name} />
                      <Product info={productList[0]} />
                    </div>
                  </a>
                  <a href={productList[1].buy_url} target="view_window" className={styles.app_slide_item}>
                    <div className={styles.product_item}>
                      <img src={ambulance + productList[1].photo} alt={productList[1].name} />
                      <Product info={productList[1]} />
                    </div>
                  </a>
                </ReactSwipe>
                <ul>
                  <li className={swipe_index === 0 ? `${styles.active_icon}` : ''}></li>
                  <li className={swipe_index === 1 ? `${styles.active_icon}` : ''}></li>
                </ul>
              </div>
            )}
          </div>

          <div className={styles.pc_swiper_container}>
            {count > 2 ? (
              <div className={styles.swiper_container}>
                <Swiper list={JSON.parse(JSON.stringify(productList)).splice(2, productList.length)} ambulance={ambulance} />
              </div>
            ) : null}
          </div>
          <div className={styles.app_swiper_container}>
            {count > 2 ? (
              <ul>
                {this.renderSwiper(productList)}
              </ul>
            ) : null}
          </div>
        </div>
        <div style={{ height: 105 }}></div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
